<template>
  <div class="form-group">
    <label :for="name" class="bold mr-1" :class="{'text-info': hasValue}">
      {{ label }}:
    </label>

    <chosen
      v-model="modelValue"
      placeholder="Select..."
      :options="options"
      :multiple="true"
      label="text"
      trackBy="id"
    >
    </chosen>

    <template v-if="modelValue.length > 0">
      <input v-for="selection in modelValue" type="hidden" :name="name + '[]'" :value="selection" />
    </template>
    <input v-else type="hidden" :name="name" value="" />

  </div>
</template>

<script>
export default {
  props: {
    name: {type: String, required: true},
    label: {type: String, required: true},
    options: {type: [Array], default: function () { return [] }},
    operatorValue: {type: String, default: ''},
    value: {type: [String, Array], default: ''},
  },

  /**
   * Variables (models).
   */
  data () {
    return {
      modelValue: this.value ?? [],
    }
  },

  /**
   * Computed values
   */
  computed: {

    hasValue() {
      return (this.value !== null) && (this.value !== '') && (this.value !== []);
    }

  },

  /**
   * Functions (methods).
   */
  methods: {
  },
}
</script>
